import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "sticky-header-wrapper mb-14"
};
var _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-0 w-full"
};
var _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-0 w-full"
};
var _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2"
};
var _hoisted_5 = {
  key: 1,
  class: "w-full h-[28px] flex items-center justify-center text-sm font-semibold text-surface-400"
};
import { ref, computed, watch } from "vue";
import TreeTable from "primevue/treetable";
import Column from "primevue/column";
import OverviewTreeTableHeader from "@/components/overview/logged-time/OverviewTreeTableHeader.vue";
import WeeklyCols from "@/components/overview/logged-time/cols/WeeklyCols.vue";
import DailyCols from "@/components/overview/logged-time/cols/DailyCols.vue";
import MainParentCell from "@/components/overview/logged-time/cell/MainParentCell.vue";
import MainChildCell from "@/components/overview/logged-time/cell/MainChildCell.vue";
import MainTimeTableCell from "@/components/overview/logged-time/cell/MainTimeTableCell.vue";
import ChildTimeTableCell from "@/components/overview/logged-time/cell/ChildTimeTableCell.vue";
import { getDateFromWeek } from "@/composables/useWeeklyDateRange.ts";
import { INTERVAL, DEPTH } from "@/utils/const";
import { getISOWeek } from "@/composables/useWeeklyDateRange.ts";
import { useOverviewThresholdSettingStore } from "@/store/pinia/useOverviewThresholdSettingStore";
import { DAY_TYPE } from "@/utils/const";
import network from "@/utils/network";
var WEEKLY_RANGE_LENGTH = 4;
var DAILY_RANGE_LENGTH = 14;
export default {
  __name: 'OverviewTreeTable',
  setup: function setup(__props) {
    var filters = ref({
      query: "",
      loggedTime: [],
      team: [],
      projects: []
    });

    // region Popover settings - Show weekends
    var overviewThresholdSettingStore = useOverviewThresholdSettingStore();
    var showWeekends = computed(function () {
      return overviewThresholdSettingStore.showWeekends;
    });
    // endregion

    var headerLabels = computed(function () {
      var _loadedOverviewItems$;
      return ((_loadedOverviewItems$ = loadedOverviewItems.value[0]) === null || _loadedOverviewItems$ === void 0 ? void 0 : _loadedOverviewItems$.timeIntervalValues.filter(function (interval) {
        return showWeekends.value ? interval.dayType !== DAY_TYPE.WEEKEND : true;
      }).map(function (interval) {
        return interval.id;
      })) || [];
    });

    // Interval
    var selectedInterval = ref(INTERVAL.DAILY);
    var selectedWeek = ref({});
    var weekRangeLength = ref(WEEKLY_RANGE_LENGTH + 1);
    var initialSelectedWeek = ref(getISOWeek(new Date()) - WEEKLY_RANGE_LENGTH); // 4 weeks ago

    var selectedDay = ref({});
    var initialSelectedDay = ref(new Date(new Date().setDate(new Date().getDate() - DAILY_RANGE_LENGTH / 2)) // 7 days ago
    );

    // Data
    var axios = network.createAxiosInstance();
    var overviewItems = ref([]);
    var loadedOverviewItems = computed(function () {
      return isLoadingOverview.value ? [] : overviewItems.value;
    });
    var isLoadingOverview = ref(true);
    var overviewError = ref(null);
    var showOverviewSkeleton = ref(false);
    var queryParams = computed(function () {
      var _selectedWeek$value, _selectedDay$value, _selectedWeek$value2, _selectedDay$value2, _filters$value$logged, _filters$value$team, _filters$value$projec;
      var aggregationType = selectedInterval.value === INTERVAL.WEEKLY ? "WEEKLY" : "DAILY";
      var startDate = selectedInterval.value === INTERVAL.WEEKLY ? (_selectedWeek$value = selectedWeek.value) === null || _selectedWeek$value === void 0 ? void 0 : _selectedWeek$value.from : (_selectedDay$value = selectedDay.value) === null || _selectedDay$value === void 0 ? void 0 : _selectedDay$value.from;
      var endDate = selectedInterval.value === INTERVAL.WEEKLY ? (_selectedWeek$value2 = selectedWeek.value) === null || _selectedWeek$value2 === void 0 ? void 0 : _selectedWeek$value2.to : (_selectedDay$value2 = selectedDay.value) === null || _selectedDay$value2 === void 0 ? void 0 : _selectedDay$value2.to;
      var params = new URLSearchParams();
      params.set("aggregationType", aggregationType);
      params.set("startDate", startDate);
      params.set("endDate", endDate);
      if (filters.value.query) {
        params.set("query", filters.value.query);
      }
      if ((_filters$value$logged = filters.value.loggedTime) !== null && _filters$value$logged !== void 0 && _filters$value$logged.length) {
        filters.value.loggedTime.forEach(function (l) {
          params.append("loggedTime", l);
        });
      }
      if ((_filters$value$team = filters.value.team) !== null && _filters$value$team !== void 0 && _filters$value$team.length) {
        filters.value.team.forEach(function (t) {
          params.append("team", t);
        });
      }
      if ((_filters$value$projec = filters.value.projects) !== null && _filters$value$projec !== void 0 && _filters$value$projec.length) {
        filters.value.projects.forEach(function (p) {
          params.append("project", p);
        });
      }
      var requiredDataTypes = ["ALLOCATION", "WORK_SCHEDULE", "TIME_OFF", "LOGGED"];
      requiredDataTypes.forEach(function (field) {
        params.append("dataType", field);
      });
      params.set("hierarchyType", "USER_ROOT_PROJECT_CHILD");
      requiredDataTypes.forEach(function (field) {
        params.append("dataType", field);
      });
      return "?".concat(params.toString());
    });
    watch(queryParams, function () {
      fetchOverview();
    }, {
      immediate: false
    });
    var fetchOverview = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isLoadingOverview.value = true;
              overviewError.value = null;
              _context.p = 1;
              _context.n = 2;
              return axios.get("/v2/enterprise/time-management/overview/user-project-diff-filtering".concat(queryParams.value));
            case 2:
              response = _context.v;
              overviewItems.value = response.data.items || [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              _context.p = 4;
              isLoadingOverview.value = false;
              showOverviewSkeleton.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function fetchOverview() {
        return _ref.apply(this, arguments);
      };
    }();

    // expandedKeys
    var expandedKeys = ref({});
    var isExpanded = function isExpanded(key) {
      return Object.keys(expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.value).includes(key);
    };

    // Utility functions
    var isNotLastChild = function isNotLastChild(key) {
      if (key.includes(DEPTH.CHILD)) {
        var parent = overviewItems.value.find(function (item) {
          return item.children.some(function (child) {
            return child.key === key;
          });
        });
        return parent.children[parent.children.length - 1].key !== key;
      } else {
        return false;
      }
    };
    var hasProblem = function hasProblem(node) {
      return node.children.some(function (child) {
        var _child$projectData;
        return (_child$projectData = child.projectData) === null || _child$projectData === void 0 ? void 0 : _child$projectData.name.includes("projectNotFound");
      });
    };

    // Exclamation mark calculation
    var headerLabelsBeforeToday = computed(function () {
      if (selectedInterval.value === INTERVAL.WEEKLY) {
        return headerLabels.value.filter(function (label) {
          var year = label.split("-")[0];
          var week = label.split("-W")[1];
          var endDate = getDateFromWeek(week, year);
          endDate.setDate(endDate.getDate() + 6);
          return endDate < new Date();
        });
      } else {
        return headerLabels.value.filter(function (label) {
          var endDate = new Date(label);
          endDate.setDate(endDate.getDate()); // + 1 if you want to exclude today
          return endDate < new Date();
        });
      }
    });
    return function (_ctx, _cache) {
      var _component_Skeleton = _resolveComponent("Skeleton");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(OverviewTreeTableHeader, {
        class: "border rounded-t-lg px-3.5 py-2 border-surface-100 bg-surface-0",
        "overview-items": overviewItems.value,
        "selected-interval": selectedInterval.value,
        "onUpdate:selectedInterval": _cache[0] || (_cache[0] = function ($event) {
          return selectedInterval.value = $event;
        }),
        "selected-day": selectedDay.value,
        "onUpdate:selectedDay": _cache[1] || (_cache[1] = function ($event) {
          return selectedDay.value = $event;
        }),
        "initial-selected-day": initialSelectedDay.value,
        "day-range-length": DAILY_RANGE_LENGTH,
        "selected-week": selectedWeek.value,
        "onUpdate:selectedWeek": _cache[2] || (_cache[2] = function ($event) {
          return selectedWeek.value = $event;
        }),
        "initial-selected-week": initialSelectedWeek.value,
        "week-range-length": weekRangeLength.value,
        filters: filters.value,
        "onUpdate:filters": _cache[3] || (_cache[3] = function ($event) {
          return filters.value = $event;
        })
      }, null, 8, ["overview-items", "selected-interval", "selected-day", "initial-selected-day", "selected-week", "initial-selected-week", "week-range-length", "filters"]), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(TreeTable), {
        value: loadedOverviewItems.value,
        scrollable: "",
        expandedKeys: expandedKeys.value,
        "onUpdate:expandedKeys": _cache[4] || (_cache[4] = function ($event) {
          return expandedKeys.value = $event;
        })
      }, {
        empty: _withCtx(function () {
          return [isLoadingOverview.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, function (i) {
            return _createVNode(_component_Skeleton, {
              key: i,
              class: "w-full !h-[84px]"
            });
          }), 64)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, function (i) {
            return _createVNode(_component_Skeleton, {
              key: i,
              class: "w-full !h-[56px]"
            });
          }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$tf("timeManagementOverview.noData|Nincs adat")), 1))];
        }),
        default: _withCtx(function () {
          return [_createVNode(_unref(Column), {
            field: "userId",
            expander: "",
            header: "",
            frozen: "",
            style: {
              "padding": "0 !important"
            },
            class: "!border-r !border-surface-200",
            pt: {
              bodycell: function bodycell(_ref2) {
                var context = _ref2.context;
                return {
                  class: "z-10 ".concat(isExpanded(context.node.key) || isNotLastChild(context.node.key) ? '!border-b-0' : '')
                };
              },
              bodycellContent: '!justify-end !border-b-0 !ml-2',
              headercell: {
                style: 'background-color: var(--p-surface-0) !important;'
              },
              nodetogglebutton: '!rounded-md hover:!bg-surface-100 cursor-pointer',
              nodetoggleicon: '!h-[2rem] !w-[1.5rem] !p-[0.25rem] !text-blue-700 dark:!text-white'
            }
          }, {
            body: _withCtx(function (_ref3) {
              var node = _ref3.node;
              return [node.key.includes(_unref(DEPTH).ROOT) ? (_openBlock(), _createBlock(MainParentCell, {
                key: 0,
                node: node,
                "has-problem": hasProblem(node)
              }, null, 8, ["node", "has-problem"])) : _createCommentVNode("", true), node.key.includes(_unref(DEPTH).CHILD) ? (_openBlock(), _createBlock(MainChildCell, {
                key: 1,
                node: node,
                "is-last-child": !isNotLastChild(node.key)
              }, null, 8, ["node", "is-last-child"])) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["pt"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerLabels.value, function (interval) {
            return _openBlock(), _createBlock(_unref(Column), {
              key: interval,
              style: {
                "min-width": "100px",
                "padding": "0 !important"
              },
              pt: {
                bodycell: '!border-b-0'
              }
            }, {
              header: _withCtx(function () {
                return [selectedInterval.value === _unref(INTERVAL).WEEKLY ? (_openBlock(), _createBlock(WeeklyCols, {
                  key: 0,
                  interval: interval,
                  "is-loading": isLoadingOverview.value
                }, null, 8, ["interval", "is-loading"])) : _createCommentVNode("", true), selectedInterval.value === _unref(INTERVAL).DAILY ? (_openBlock(), _createBlock(DailyCols, {
                  key: 1,
                  "overview-items": overviewItems.value,
                  interval: interval,
                  "is-loading": isLoadingOverview.value
                }, null, 8, ["overview-items", "interval", "is-loading"])) : _createCommentVNode("", true)];
              }),
              body: _withCtx(function (_ref4) {
                var node = _ref4.node;
                return [node.key.includes(_unref(DEPTH).ROOT) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(MainTimeTableCell, {
                  node: node,
                  "interval-id": interval,
                  field: "workScheduleTime",
                  "header-labels-before-today": headerLabelsBeforeToday.value,
                  "selected-interval": selectedInterval.value
                }, null, 8, ["node", "interval-id", "header-labels-before-today", "selected-interval"]), _createVNode(MainTimeTableCell, {
                  node: node,
                  "interval-id": interval,
                  field: "loggedTime",
                  "header-labels-before-today": headerLabelsBeforeToday.value,
                  "selected-interval": selectedInterval.value
                }, null, 8, ["node", "interval-id", "header-labels-before-today", "selected-interval"]), _createVNode(MainTimeTableCell, {
                  node: node,
                  "interval-id": interval,
                  field: "timeOff",
                  "header-labels-before-today": headerLabelsBeforeToday.value,
                  "selected-interval": selectedInterval.value
                }, null, 8, ["node", "interval-id", "header-labels-before-today", "selected-interval"])])) : node.key.includes(_unref(DEPTH).CHILD) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(ChildTimeTableCell, {
                  "loaded-overview-items": loadedOverviewItems.value,
                  node: node,
                  "interval-id": interval,
                  field: "allocatedTime",
                  "header-labels-before-today": headerLabelsBeforeToday.value,
                  hasBorderBottom: ""
                }, null, 8, ["loaded-overview-items", "node", "interval-id", "header-labels-before-today"]), _createVNode(ChildTimeTableCell, {
                  "loaded-overview-items": loadedOverviewItems.value,
                  node: node,
                  "interval-id": interval,
                  field: "loggedTime",
                  "header-labels-before-today": headerLabelsBeforeToday.value,
                  hasBorderBottom: ""
                }, null, 8, ["loaded-overview-items", "node", "interval-id", "header-labels-before-today"])])) : _createCommentVNode("", true)];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      }, 8, ["value", "expandedKeys"])])]);
    };
  }
};